
  document.addEventListener("DOMContentLoaded", function () {
    const wishlistKey = "wishlist";
    const container = document.getElementById("wishlist-products");

    function getWishlist() {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    }

    function saveWishlist(data) {
      localStorage.setItem(wishlistKey, JSON.stringify(data));
    }

    function updateButtonIcon(button, inWishlist) {
      const icon = button.querySelector("i");
      if (!icon) return;

      if (inWishlist) {
        button.classList.add("in-wishlist");
        icon.classList.remove("bi-heart");
        icon.classList.add("bi-heart-fill");
      } else {
        button.classList.remove("in-wishlist");
        icon.classList.remove("bi-heart-fill");
        icon.classList.add("bi-heart");
      }
    }

    function bindWishlistToggleButtons() {
      document.querySelectorAll(".add-to-wishlist").forEach(button => {
        const handle = button.dataset.handle;
        let wishlist = getWishlist();
        const isInWishlist = wishlist.includes(handle);

        updateButtonIcon(button, isInWishlist);

        button.addEventListener("click", function (e) {
          e.preventDefault();
          wishlist = getWishlist();
          const index = wishlist.indexOf(handle);

          if (index === -1) {
            wishlist.push(handle);
          } else {
            wishlist.splice(index, 1);
          }

          saveWishlist(wishlist);
          updateButtonIcon(button, index === -1);

          // If on the wishlist page, reload after removing
          if (document.getElementById("wishlist-products")) {
            loadWishlist();
          }
        });
      });
    }

    function bindRemoveButtons() {
      document.querySelectorAll(".remove-from-wishlist").forEach(button => {
        button.addEventListener("click", function () {
          const handle = this.dataset.handle;
          let wishlist = getWishlist();
          wishlist = wishlist.filter(item => item !== handle);
          saveWishlist(wishlist);
          loadWishlist();
        });
      });
    }

    function loadWishlist() {
      if (!container) return;

      const wishlist = getWishlist();
      container.innerHTML = ""; // Clear

      if (wishlist.length === 0) {
        container.innerHTML = "<p class='text-center'>Your wishlist is empty.</p>";
        return;
      }

      fetch("/collections/all?view=wishlist-json")
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          wishlist.forEach(handle => {
            const card = doc.querySelector(`[data-product-handle="${handle}"]`);
            if (card) {
              container.appendChild(card.cloneNode(true));
            }
          });

          bindRemoveButtons();
          bindWishlistToggleButtons();
        })
        .catch(error => {
          console.error("Failed to load wishlist:", error);
          container.innerHTML = "<p class='text-danger'>Failed to load wishlist items.</p>";
        });
    }

    // Run on all pages
    bindWishlistToggleButtons();

    // Run wishlist page script only if the container exists
    if (container) {
      loadWishlist();
    }
  });

